import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take, withLatestFrom } from 'rxjs/operators';
import { NewsletterOptInDialogComponent } from './newsletter-opt-in-dialog.component';
import { UserSettingsStateService } from '../user-settings-state.service';

@Injectable({
  providedIn: 'root',
})
export class NewsletterOptInDialogService {
  constructor(
    private dialog: MatDialog,
    private userSettingsState: UserSettingsStateService,
  ) {
    this.userSettingsState.isInitialized$.pipe(
      withLatestFrom(this.userSettingsState.newsletterOptIn$),
      take(1),
    ).subscribe(([_, newsletterOptIn]) => {
      if (newsletterOptIn === null) {
        this.dialog.open(NewsletterOptInDialogComponent, {
          enterAnimationDuration: 0,
          exitAnimationDuration: 0,
          disableClose: true,
          data: {
            hasCloseButton: false,
            autoClose: false,
            title: 'Einwilligung E-Mail-Versand',
            acceptLabel: 'Ja',
            dismissLabel: 'Nein',
          },
          hasBackdrop: true,
        });
      }
    });
  }
}
